module.exports = __webpack_public_path__ + "src/assets/img/guestlist_one_deluxe2.f89d70fc.jpg";